<template>
    <section id="container">
        <section id="user-visual" class="mypage">
            <div class="grid--con">
                <div class="user-visual-txt">고객지원<!--<span> 궁금한 점이 있으신가요? 고객센터에서 해결 방법을 찾아보세요.</span>--></div>
            </div>
        </section>

        <section id="lnb">
            <div class="grid--lnb">
                <div class="grid--con">
                    <div class="pt-lnb">
                        <ul>
                            <li v-for="(tabInfo, index) in csTabList"
                                :key="'csTab_'+index"
                                :class="selComponentNm == tabInfo.componentNm? 'current':''"
                                @click="btn_csTabClick(tabInfo)">
                                <a href="javascript:;">{{tabInfo.tabNm}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <!-- lnb end -->

        <!-- content start -->
        <!--<div id="content" class="sub">
        </div>-->
        <component v-bind:is="selComponentNm"></component>
    </section>
</template>

<script>
    export default {
        name: 'cs',
        data:function(){
            return {
                selComponentNm:'',
                csTabList : [
                    {tabNm : '공지사항', componentNm : 'notice'},
                    {tabNm : 'FAQ', componentNm : 'faq'},
                    {tabNm : '1:1 문의', componentNm : 'qstn'},
                    {tabNm : '원격지원', componentNm : 'remoteSupport'},
                ],
            }
        },
        computed: {
            loginAt : function(){
                return this.$store.getters.getLoginAt;
            },
        },
        methods: {
            init: function(){
                if(this.$route.params.componentNm != 'undefined' && this.$route.params.componentNm != null){
                    this.selComponentNm = this.$route.params.componentNm;
                }else{
                    this.selComponentNm = 'notice';
                }

            },
            btn_csTabClick : function(tabInfo){
                if(tabInfo.componentNm == 'qstn'&&!this.loginAt){
                    alert('로그인이 필요합니다.');
                    this.$router.push({ name: 'views.i5gam.index'});
                }
                this.selComponentNm = tabInfo.componentNm;
            },
        },
        mounted: function(){
            this.init();
        }
    }
</script>

<style scoped>

</style>